// extracted by mini-css-extract-plugin
module.exports = {"primary":"CrossButton_primary__3dGV0","darkRounded":"CrossButton_darkRounded__3vK1t","rounded":"CrossButton_rounded__2USMj"};